import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import type { GradientSectionResolved } from './types';
import { SlotRenderer } from '@/components/SlotRenderer';
import { useCollapseWhenEmpty } from '@/lib/render/collapseWhenEmpty';
import { getSectionColorVar } from '@/lib/section-colors';

export const GradientSectionComponent = ({
  resolved,
}: {
  resolved: GradientSectionResolved;
}) => {
  const { topColor, bottomColor, hideOnMobile, blocks } = resolved;
  const collapseWhenEmpty = useCollapseWhenEmpty();
  const top = topColor ? getSectionColorVar(topColor) : 'transparent';
  const bottom = getSectionColorVar(bottomColor);

  return (
    <section
      style={{ background: `linear-gradient(to bottom, ${top}, ${bottom})` }}
      className={classNames(
        // `relative` only — deliberately no z-index. A z-index here would make
        // the section a stacking context and cap every descendant inside it,
        // so an open ZipCity dropdown could never paint over the *next*
        // section. Painting above a preceding hero that overlaps into this
        // section (HeroComponentB's `-mb-16`) is already handled by the
        // `relative` wrapper SlotRenderer puts around every block plus DOM
        // order — the z-index was redundant for that.
        // `pb-4` is an exception to the top-padding-only convention
        // (CLAUDE.md): the section paints a gradient, so its last block must
        // not sit flush against the coloured edge.
        'relative pt-4 pb-4',
        // Nothing to paint a gradient around when every block inside
        // hid itself — see `globals.css`.
        collapseWhenEmpty,
        hideOnMobile && 'hidden md:block',
      )}
    >
      {/* The gradient is full-bleed, its contents are not. `container="page"`
          rather than one wrapping div so a block that opts out —
          `layout: 'self'` — still escapes, exactly as it would at page level
          (70.14-Widget-Width). */}
      <SlotRenderer blocks={blocks} zoneName="blocks" container="page" />
    </section>
  );
};
